/* September 2026 promotion. Shopify remains authoritative for all prices. */
(function () {
  'use strict';
  if (window.NoodyBestieGift) return;
  var start = Date.parse('2026-09-10T06:00:00Z');
  var end = Date.parse('2026-09-13T11:59:00Z');
  var variant = 50106650951963;
  var eligibleIds = [8225385021723, 8502656467227, 8502668067099, 10080184303899];
  var marker = 'bestie-september-2026';
  var root = (window.Shopify && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve();
  var checkoutBusy = false;
  function active() { return Date.now() >= start && Date.now() < end; }
  function managed(item) { return item.variant_id === variant && item.properties && item.properties._noody_gift === marker; }
  function request(path, body) {
    return nativeFetch(root + path, {
      credentials: 'same-origin',
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return r.json(); });
  }
  function note(message) {
    document.querySelectorAll('[data-noody-gift-status]').forEach(function (el) { el.textContent = message; });
  }
  async function reconcile() {
    var cart = await request('cart.js');
    var count = cart.items.reduce(function (n, item) {
      return n + (eligibleIds.indexOf(item.product_id) !== -1 && !item.selling_plan_allocation ? item.quantity : 0);
    }, 0);
    var gifts = cart.items.filter(managed);
    // Never alter an ordinary Bedtime Bestie that the customer added themselves.
    var ordinaryBestie = cart.items.some(function (item) { return item.variant_id === variant && !managed(item) && !item.selling_plan_allocation; });
    var wanted = active() && count >= 2 && !ordinaryBestie;
    for (var i = 0; i < gifts.length; i++) {
      var quantity = wanted && i === 0 ? 1 : 0;
      if (gifts[i].quantity !== quantity) cart = await request('cart/change.js', { id: gifts[i].key, quantity: quantity });
    }
    if (wanted && !gifts.length) {
      try {
        await request('cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _noody_gift: marker } }] });
        cart = await request('cart.js');
      } catch (err) {
        note('Your qualifying items are in your bag. The gift could not be added; please retry or contact us before checkout.');
        return cart;
      }
    }
    var unpaidGift = cart.items.filter(function (item) { return managed(item) && item.final_line_price > 0; });
    for (var j = 0; j < unpaidGift.length; j++) {
      cart = await request('cart/change.js', { id: unpaidGift[j].key, quantity: 0 });
    }
    if (unpaidGift.length) note('The free gift cannot combine with your current discount. Your automatically added gift has been removed.');
    return cart;
  }
  function enqueue(work) {
    var next = queue.then(work, work);
    queue = next.catch(function () {});
    return next;
  }
  window.fetch = function (input, options) {
    var url = new URL(typeof input === 'string' ? input : input.url, location.href);
    var isMutation = url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    if (!isMutation) return nativeFetch(input, options);
    return enqueue(async function () {
      var response = await nativeFetch(input, options);
      if (!response.ok) return response;
      var cart = await reconcile();
      var original = await response.clone().json();
      if (/\/cart\/add/.test(url.pathname)) {
        function refreshed(item) {
          var current = cart.items.find(function (line) { return line.variant_id === (item.variant_id || item.id) && Boolean(line.selling_plan_allocation) === Boolean(item.selling_plan_allocation) && !managed(line); });
          return current ? Object.assign({}, item, { final_price: current.final_price, discounted_price: current.final_price, price: current.price }) : item;
        }
        var added = original.items ? Object.assign({}, original, { items: original.items.map(refreshed) }) : refreshed(original);
        return new Response(JSON.stringify(added), { status: response.status, headers: { 'Content-Type': 'application/json' } });
      }
      // Preserve bundled section responses used by theme clients.
      if (original.sections) {
        var sectionUrl = new URL(location.href);
        sectionUrl.searchParams.set('sections', Object.keys(original.sections).join(','));
        var sectionResponse = await nativeFetch(sectionUrl.toString(), { credentials: 'same-origin' });
        cart.sections = sectionResponse.ok ? await sectionResponse.json() : original.sections;
      }
      return new Response(JSON.stringify(cart), { status: response.status, headers: { 'Content-Type': 'application/json' } });
    });
  };
  async function checkout(event) {
    var anchor = event.target.closest && event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
    if (!anchor || checkoutBusy) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkoutBusy = true;
    try {
      await enqueue(reconcile);
      location.assign(root + 'checkout');
    } catch (err) {
      checkoutBusy = false;
      note('Please refresh your bag before checking out so we can confirm the gift price.');
    }
  }
  document.addEventListener('click', checkout, true);
  window.NoodyBestieGift = { sync: function () { return enqueue(reconcile); } };
  function init() {
    enqueue(reconcile).then(function () {
      if (window.BWDrawer) window.BWDrawer.refresh();
    }).catch(function () { note('Please refresh your bag to confirm the free gift.'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
